import React from 'react';
import ReactDOM from 'react-dom';
import './polyfills';
import * as Sentry from '@sentry/react';
import './Environment';
import { App } from './app/app';
import { Environment } from 'src/Environment';
import './sass/global.scss';

if (!Environment?.current?.disabledFeatures?.sentry) {
  Sentry.init({
    dsn: Environment.current.sentry.dsn,
    maxBreadcrumbs: Environment.current.sentry.maxBreadcrumbs,
    environment: Environment.current.name,
    release: `${Environment.current.sentry.appName}@${process.env.REACT_APP_GIT_SHA}`,
    tracesSampleRate: Environment.current.sentry.tracesSampleRate,
    allowUrls: Environment.current.sentry.allowUrls,
    denyUrls: Environment.current.sentry.denyUrls,
    integrations: [new Sentry.BrowserTracing()],
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
